import { useMemo, useState, useEffect } from "react";
import Menu from "../../../../components/layout/menu/index";
import { getDocuments, createDocument, updateDocument, deleteDocument } from '../../../../client/documents';
import ModalSuccess from "../../../../components/shared/modals/modalSuccess";
import ModalDelete from "../../../../components/shared/modals/modalDelete";
import ModalAlertWarning from "../../../../components/shared/modals/modalAlertWarning";
import Pagination from "../../../../components/shared/pagination";
import ContentLoader from "react-content-loader";

function cx(...classes) {
  return classes.filter(Boolean).join(" ");
}

function Switch({ checked, onChange, label }) {
  return (
    <button
      type="button"
      onClick={() => onChange(!checked)}
      className={cx(
        "relative inline-flex h-6 w-11 items-center rounded-full transition-colors focus:outline-none",
        checked ? "bg-blue-600" : "bg-gray-500"
      )}
      aria-pressed={checked}
      aria-label={label}
    >
      <span
        className={cx(
          "inline-block h-5 w-5 transform rounded-full bg-white shadow transition-transform",
          checked ? "translate-x-5" : "translate-x-1"
        )}
      />
    </button>
  );
}

export default function Documents() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [rows, setRows] = useState(() => []);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const [editorOpen, setEditorOpen] = useState(false);
  const [editing, setEditing] = useState(null);
  const [deleting, setDeleting]= useState(null);
  const [form, setForm] = useState({ name: "", multiple: false, perPlant: false });

  const [showModalSuccess, setShowModalSuccess] = useState(false);
  const [showModalDelete, setShowModalDelete] = useState(false);
  const [showModalAlertWarning, setShowModalAlertWarning] = useState(false); 
  const [modalSuccessText, setModalSuccessText] = useState("");
  const [modalErrorText, setModalErrorText] = useState(""); 
  const [isLoading, setIsLoading] = useState(false);

const [page, setPage] = useState(1);
const [pageSize, setPageSize] = useState(10);
const [totalPages, setTotalPages] = useState(1);
const [totalCount, setTotalCount] = useState(0);

  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);

async function loadDocuments() {
  try {
    setLoading(true);
    const res = await getDocuments(page, pageSize);
    setRows(res.data.data);
    setTotalPages(res.data.totalPages);
    setTotalCount(res.data.totalCount);
  } 
  catch (e) {
    console.error(e);
    setError(e.message || String(e));
  }
   finally {
    setLoading(false);
  }
}

useEffect(() => { loadDocuments(); }, [page, pageSize]);

  function openEdit(row) {
    setEditing(row);
    setForm({ name: row.name, multiple: row.multiple, perPlant: row.perPlant });
    setEditorOpen(true);
  }

  async function saveForm(e) {
    e.preventDefault();

    const payload = {
      name: form.name.trim(),
      multiple: form.multiple,
      perPlant: form.perPlant,
    };

    if (!payload.name) return;

    try {
      if (editing) {
        await updateDocument(editing.id, payload);
      } else {
        await createDocument(payload.name, payload.multiple, payload.perPlant);
      }

      await loadDocuments();
      setEditorOpen(false);
      setModalSuccessText(`¡Su documento fue ${editing ? 'editado' : 'agregado'} con éxito!`)
      setShowModalSuccess(true);
      resetForm();
    }
catch (e) {
  console.error(e);

  let errorMessage = "Error al guardar el documento.";

  if (e?.response?.data) {
    if (typeof e.response.data === "object" && e.response.data.message) {
      errorMessage = e.response.data.message;
    } else if (typeof e.response.data === "string") {
      errorMessage = e.response.data;
    }
  } else if (e?.message) {
    errorMessage = e.message;
  }

  setModalErrorText(errorMessage);
  setShowModalAlertWarning(true);
}

  }

  function resetForm() {
    setEditing(null);
    setForm({ name: "", multiple: false, perPlant: false });
  }

  function handleInlineToggle(row, field) {
    const updated = { ...row, [field]: !row[field] };
    updateRow(updated);
  }

  function updateRow(updated, options = {}) {
    if (options.openEditor) return openEdit(updated);
    (async () => {
      try {
        await updateDocument(updated.id, {
          name: updated.name,
          multiple: updated.multiple,
          perPlant: updated.perPlant,
        });
        await loadDocuments();
        setModalSuccessText("¡Su documento fue editado con éxito!");
        setShowModalSuccess(true);
      } catch (e) {
        console.error(e);
        const errorMessage = e?.message || e?.response?.data?.message || "Error al actualizar el documento";
        setModalErrorText(errorMessage);
        setShowModalAlertWarning(true);
      }
    })();
  }

  function handleConfirmDelete() {
    (async () => {
      try {
        await deleteDocument(deleting.id);
        await loadDocuments();
        setShowModalDelete(false);
        setModalSuccessText("¡Su documento fue eliminado con éxito!");
        setShowModalSuccess(true);
      } catch (e) {
        console.error(e);
        const errorMessage = e?.message || e?.response?.data?.message || "Error al eliminar el documento";
        setModalErrorText(errorMessage);
        setShowModalAlertWarning(true);
      }
    })();
  }

  return (
    <div>
      <Menu isMenuOpen={isMenuOpen} toggleMenu={toggleMenu} className="transition-all duration-300" />
      <div className={`flex-1 pt-[67px] transition-all duration-300 ${isMenuOpen ? "xl:pl-[20.7%] lg:pl-[23.7%] pl-0" : "pl-0"} bg-[#F7F8F9] w-full z-50 min-h-screen`}>
        <div className="md:pt-8 pt-4 pb-10 px-[3%] flex flex-col gap-4">
          <h1 className="text-blue font-itcbold text-2xl md:text-[32px]">
            Documentos
          </h1>
          <div className="flex flex-col items-start justify-center gap-4 ">
            <div className="flex items-center justify-center w-full">
              <div className="bg-[#00769633] flex  md:flex-row flex-col items-center justify-center gap-6 w-full rounded-2xl p-4">
                <div className="flex flex-row  md:flex-col w-full md:w-[20%] justify-center gap-4 items-center md:items-start">
                  <p className="text-blue font-itcdemi text-[24px] text-left">
                    {editing ? 'Editar documento' : 'Agregar documento'}
                  </p>
                </div>
                <div className="flex flex-col md:flex-row items-center justify-between w-full md:w-[60%] gap-3 md:gap-8">
                  <div className="grid w-full grid-cols-1 gap-6 sm:grid-cols-2 ">
                    <div className="flex flex-col gap-2 ">
                      <p className="font-itcdemi text-[#1F1F1F] lg:text-[14px] text-[16px]">Nombre: <span className="text-red-500">*</span></p>
                      <div className="border w-full bg-white flex rounded-[6px] border-[#D1D5DB]">
                        <input
                          value={form.name}
                          onChange={(e) => {
                            const value = e.target.value;
                            const filteredValue = value.replace(/[^a-zA-Z0-9áéíóúÁÉÍÓÚñÑ\s]/g, '');
                            const limitedValue = filteredValue.slice(0, 50);
                            setForm(f => ({ ...f, name: limitedValue }));
                          }}
                          className="rounded-[6px] w-full outline-none p-2 placeholder:font-itcbook font-itcbook placeholder:text-[14px] text-[14px]"
                          placeholder="Escribir nombre..."
                          maxLength={50}
                        />
                      </div>
                    </div>
                    <div className="flex items-start justify-around md:justify-between">
                      <div className="flex flex-col gap-2 ">
                        <p className="font-itcdemi text-[#1F1F1F] lg:text-[14px] text-[16px] mb-1">Múltiple:</p>
                        <div className=" w-full flex rounded-[6px] border-[#D1D5DB]">
                          <Switch
                            checked={form.multiple}
                            onChange={(v) => setForm(f => ({ ...f, multiple: v }))}
                            label="Multiple"
                          />
                        </div>
                      </div>
                      <div className="flex flex-col gap-2 ">
                        <p className="font-itcdemi text-[#1F1F1F] lg:text-[14px] text-[16px] mb-1">Por Planta:</p>
                        <div className="w-full flex rounded-[6px] border-[#D1D5DB]">
                          <Switch
                            checked={form.perPlant}
                            onChange={(v) => setForm(f => ({ ...f, perPlant: v }))}
                            label="PerPlant"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="flex flex-row  md:flex-col justify-center items-center h-full w-full md:w-[30%] gap-6">
                  <button
                    onClick={saveForm}
                    disabled={(!form.name)}
                    className={`text-white bg-blue rounded-lg w-[161px] h-[50px] font-itcdemi text-[18px]
                      ${!form.name ? 'bg-gray cursor-not-allowed' : 'cursor-pointer'}`}
                  >
                    Guardar
                  </button>
                  <button
                    onClick={resetForm}
                    className={`text-blue w-[161px] h-[50px] font-itcdemi rounded-lg text-[18px] border-[2px] border-blue`}
                  >
                    Cancelar
                  </button>
                </div>
              </div>
            </div>
            <div className="w-full">
              {loading ? (
              <div className="bg-white border p-3 border-[#D9D9D9] rounded-lg overflow-hidden">
                <ContentLoader
                  speed={2}
                  width="100%"
                  height={400}
                  backgroundColor="#f3f3f3"
                  foregroundColor="#e0e0e0"
                >
                  {/* Cabecera */}
                  <rect x="0" y="20" rx="4" ry="4" width="10%" height="25" />  {/* # */}
                  <rect x="12%" y="20" rx="4" ry="4" width="35%" height="25" /> {/* Nombre */}
                  <rect x="49%" y="20" rx="4" ry="4" width="15%" height="25" /> {/* Múltiple */}
                  <rect x="66%" y="20" rx="4" ry="4" width="15%" height="25" /> {/* Por planta */}
                  <rect x="83%" y="20" rx="4" ry="4" width="15%" height="25" /> {/* Acciones */}

                  {/* Filas */}
                  {Array.from({ length: 8 }).map((_, i) => (
                    <>
                      <rect key={`col1-${i}`} x="0" y={60 + i * 40} rx="4" ry="4" width="10%" height="25" />
                      <rect key={`col2-${i}`} x="12%" y={60 + i * 40} rx="4" ry="4" width="35%" height="25" />
                      <rect key={`col3-${i}`} x="49%" y={60 + i * 40} rx="4" ry="4" width="15%" height="25" />
                      <rect key={`col4-${i}`} x="66%" y={60 + i * 40} rx="4" ry="4" width="15%" height="25" />
                      <rect key={`col5-${i}`} x="83%" y={60 + i * 40} rx="4" ry="4" width="15%" height="25" />
                    </>
                  ))}
                </ContentLoader>
              </div>         
              ) : (
                <>
                <div className="flex items-center mb-2 space-x-2 text-sm font-itcbook">
                  <p>Mostrar</p>
                  <div className="border-[#D1D5DB] border-[1px] rounded-md w-[58px] flex justify-center items-center h-[40px]">
                    <select
                      className="w-full h-full px-2 text-sm bg-white rounded-md outline-none cursor-pointer font-itcbook"
                      value={pageSize}
                      onChange={(e) => { setPageSize(Number(e.target.value)); setPage(1); }}
                    >
                      {[10, 15, 25, 50].map(n => (
                        <option key={n} value={n}>{n}</option>
                      ))}
                    </select>
                  </div>
                  <p>Registros</p>
                </div>
                <div className="w-full overflow-hidden overflow-x-auto">
                  <table className="w-full bg-white border border-collapse table-fixed border-blue">
                    <thead>
                      <tr className='text-[14px] 2xl:text-[16px] leading-tight text-center font-itcbold'>
                        <th
                          className={`p-3 w-[80px] border text-center  border-[#D9D9D9]`}
                        >
                          #
                        </th>
                        <th
                          className={`p-3 w-[200px] border text-center  border-[#D9D9D9]`}
                        >
                          Nombre
                        </th>
                        <th
                          className={`p-3 border w-[150px] text-center  border-[#D9D9D9]`}
                        >
                          Múltiple
                        </th>
                        <th
                          className={`p-3 border w-[150px]  text-center  border-[#D9D9D9]`}
                        >
                          Por planta
                        </th>
                        <th
                          className={`p-3 border w-[150px]  text-center  border-[#D9D9D9]`}
                        >
                          Acciones
                        </th>
                      </tr>
                    </thead>
                    <tbody className='transition-all duration-300 ease-in-out'>
                      {rows.map((r, i) => {
                        return (
                          <tr className={`text-[13px] 2xl:text-[15px] p-3 border-collapse h-[62px] font-itcmedium text-left bg-white`}>
                            <td className="p-3 text-center border border-[#D9D9D9]">
                              {(page - 1) * pageSize + (i + 1)}
                            </td>
                            <td className="p-3 text-center border border-[#D9D9D9]">
                              {r.name}
                            </td>
                            <td className="p-3 text-center border border-[#D9D9D9]">
                              <Switch
                                checked={r.multiple}
                                onChange={(v) => handleInlineToggle(r, "multiple")}
                                label="Multiple"
                              />
                            </td>
                            <td className="p-3 text-center border border-[#D9D9D9]">
                              <Switch
                                checked={r.perPlant}
                                onChange={(v) => handleInlineToggle(r, "perPlant")}
                                label="PerPlant"
                              />
                            </td>
                            <td className="p-3 text-center border border-[#D9D9D9]">
                              <div className="flex flex-col items-center justify-center gap-2">
                                <button
                                  onClick={() => {
                                    setEditing(r);
                                    setForm({ name: r.name, multiple: r.multiple, perPlant: r.perPlant })
                                  }}
                                  className="p-2 flex justify-center items-center bg-[#EFEEF7] rounded-[4px] border-[#D9D9D9] border-[1px] w-[39px] h-[27px] hover:bg-blue hover:text-white transition-colors"
                                >
                                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M4.333 16.048L16.57 3.81004C17.0534 3.34741 17.6988 3.09245 18.3679 3.09976C19.037 3.10707 19.6767 3.37608 20.1499 3.84917C20.6231 4.32226 20.8923 4.96183 20.8998 5.63093C20.9073 6.30003 20.6525 6.94547 20.19 7.42904L7.951 19.667C7.6718 19.9463 7.31619 20.1366 6.929 20.214L3 21L3.786 17.07C3.86345 16.6828 4.05378 16.3272 4.333 16.048Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                    <path d="M14.5 6.5L17.5 9.5" stroke="currentColor" strokeWidth="2" />
                                  </svg>
                                </button>
                                <button
                                  onClick={() => {
                                    setDeleting(r);
                                    setShowModalDelete(true);
                                  }}
                                  className="p-2 flex justify-center items-center bg-[#EFEEF7] rounded-[4px] border-[#D9D9D9] border-[1px] w-[39px] h-[27px] hover:bg-red hover:text-white transition-colors"
                                >
                                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M12.7008 3.10083L12.945 4.79167H16.25C16.4158 4.79167 16.5747 4.85751 16.6919 4.97472C16.921 5.25091 16.875 5.41667 16.25 6.04167H15.6092L14.8817 14.5292C14.8375 15.0458 14.8017 15.4708 14.7442 15.8142C14.6858 16.1717 14.5967 16.4917 14.4225 16.7883C14.149 17.2543 13.7424 17.6278 13.255 17.8608C12.945 18.0083 12.6183 18.0692 12.2567 18.0975C11.9092 18.125 11.4833 18.125 10.965 18.125H9.035C8.51667 18.125 8.09083 18.125 7.74333 18.0975C7.38167 18.0692 7.055 18.0083 6.745 17.8608C6.25757 17.6278 5.85098 17.2543 5.5775 16.7883C5.4025 16.4917 5.315 16.1717 5.25583 15.8142C5.19833 15.47 5.1625 15.0458 5.11833 14.5292L4.39083 6.04167H3.75C3.58424 6.04167 3.42527 5.97582 3.30806 5.85861C3.19085 5.7414 3.125 5.58243 3.125 5.41667C3.125 5.25091 3.19085 5.09193 3.30806 4.97472C3.42527 4.85751 3.58424 4.79167 3.75 4.79167H7.055L7.29917 3.10083L7.30833 3.05C7.46 2.39167 8.025 1.875 8.73333 1.875H11.2667C11.975 1.875 12.54 2.39167 12.6917 3.05L12.7008 3.10083ZM8.3175 4.79167H11.6817L11.4683 3.31167C11.4283 3.1725 11.3267 3.125 11.2658 3.125H8.73417C8.67333 3.125 8.57167 3.1725 8.53167 3.31167L8.3175 4.79167ZM9.375 8.75C9.375 8.58424 9.30915 8.42527 9.19194 8.30806C9.07473 8.19085 8.91576 8.125 8.75 8.125C8.58424 8.125 8.42527 8.19085 8.30806 8.30806C8.19085 8.42527 8.125 8.58424 8.125 8.75V12.9167C8.125 13.0824 8.19085 13.2414 8.30806 13.3586C8.42527 13.4758 8.58424 13.5417 8.75 13.5417C8.91576 13.5417 9.07473 13.4758 9.19194 13.3586C9.30915 13.2414 9.375 13.0824 9.375 12.9167V8.75ZM11.875 8.75C11.875 8.58424 11.8092 8.42527 11.6919 8.30806C11.5747 8.19085 11.4158 8.125 11.25 8.125C11.0842 8.125 10.9253 8.19085 10.8081 8.30806C10.6908 8.42527 10.625 8.58424 10.625 8.75V12.9167C10.625 13.0824 10.6908 13.2414 10.8081 13.3586C10.9253 13.4758 11.0842 13.5417 11.25 13.5417C11.4158 13.5417 11.5747 13.4758 11.6919 13.3586C11.8092 13.2414 11.875 13.0824 11.875 12.9167V8.75Z" fill="currentColor" />
                                  </svg>
                                </button>
                              </div>
                            </td>
                          </tr>
                        )
                      })}
                    </tbody>
                  </table>
                </div>
                <Pagination
  currentPage={page}
  totalPages={totalPages}
  changePage={setPage}
  recordsPerPage={pageSize}
  totalRecords={totalCount}
/>
</>
              )}
            </div>
          </div>
        </div>
      </div>
      <ModalSuccess
        showModalSuccess={showModalSuccess}
        closeModalSuccess={() => setShowModalSuccess(false)}
        fill="green"
        text={modalSuccessText}
      />
      <ModalDelete
        showModalDelete={showModalDelete}
        closeModal={() => setShowModalDelete(false)}
        accept={handleConfirmDelete}
        textType="documento"
      />

      <ModalAlertWarning
        showModalAlertWarning={showModalAlertWarning}
        closeModal={() => setShowModalAlertWarning(false)}
        error={modalErrorText}
        accept={() => setShowModalAlertWarning(false)}
      />
    </div>
  )

}
